import { useState } from 'react';
import { ShieldCheck, Loader, Lock } from 'lucide-react';
import { useAuth } from '../AuthContext';

const AdminGateScreen = ({ needsElevation }) => {
  const { login } = useAuth();
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passcode || busy) return;
    setBusy(true);
    setError('');
    try {
      await login(passcode);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Incorrect passcode');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#0d1f15' }}>
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl border border-[#e8dfc7] p-8">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#1f3d2b]/10 flex items-center justify-center mb-4">
            <ShieldCheck className="text-[#1f3d2b]" size={26} />
          </div>
          <h1 className="text-2xl tracking-tight" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#0d1f15' }}>
            Wellness Admin
          </h1>
          <p className="text-sm text-[#5a7062] mt-2">
            {needsElevation
              ? 'You are signed in as staff. Enter the admin passcode to open the business dashboard.'
              : 'Enter the admin passcode to manage bookings, pricing, and members.'}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            data-testid="wellness-admin-passcode-input"
            type="password"
            inputMode="numeric"
            autoFocus
            value={passcode}
            onChange={(e) => { setPasscode(e.target.value); if (error) setError(''); }}
            placeholder="Admin passcode"
            className="w-full h-12 px-4 text-lg tracking-widest text-center border border-[#d8cfb4] rounded-xl focus:outline-none focus:border-[#d97736] focus:ring-2 focus:ring-[#d97736]/20 transition"
          />
          {error && (
            <div data-testid="wellness-admin-passcode-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="wellness-admin-passcode-submit"
            type="submit"
            disabled={busy || !passcode}
            className="w-full bg-[#1f3d2b] hover:bg-[#16301f] text-white font-bold rounded-xl h-12 text-base transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {busy ? <><Loader className="animate-spin" size={18} /> Unlocking…</> : <><Lock size={16} /> Enter Dashboard</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminGateScreen;
